<template>
  <div  
  :class="`grid c_${component.id}__container c_${component.id}__container_${theme_id ?? ''}`"
  v-if="showCrossSaleProduct">
    
  <!-- Image Container -->
    <div
    :class="`grid c_${component.id}__image_container c_${component.id}__image_container_${theme_id ?? ''}`"
    >
      <img 
            :src="cross_sale_product.image_url" 
            :class="`grid c_${component.id}__product_image c_${component.id}__product_image_${theme_id ?? ''}`"
            >
    </div>

    <!-- Text Container -->
    <div :class="`grid c_${component.id}__text_container c_${component.id}__text_container_${theme_id ?? ''}`">
      
      <!-- Checkbox -->
      <div :class="`flex c_${component.id}__checkbox c_${component.id}__checkbox_${theme_id ?? ''}`">
        <input
          :id="`csp_${cross_sale_product.id}`"  
          type="checkbox"
          value="true"
          v-model="cross_sale_product.selected"
          class="checkbox"
        />

        <label
        :for="`csp_${cross_sale_product.id}`"  
        class="ml-2"
          >
          {{ cross_sale_product.label_text }}
          <span> for ${{ formatPrice(price) }} per item</span>
        </label>
      </div>

      <!-- Quantity -->
      <div :class="`grid c_${component.id}__quantity c_${component.id}__quantity_${theme_id ?? ''}`">
        <div :class="`grid c_${component.subcomponents.quantity_input.id}__container c_${component.subcomponents.quantity_input.id}__container_${theme_id ?? ''}`">

          <span :class="`grid c_${component.subcomponents.quantity_input.id}__reduce_button c_${component.subcomponents.quantity_input.id}__reduce_button_${theme_id ?? ''} c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">

            <button 
            :class="`c_${component.subcomponents.quantity_input.subcomponents.button.id}__button c_${component.subcomponents.quantity_input.subcomponents.button.id}__button_${theme_id ?? ''}`"
            @click="decreaseQuantity">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 172 172"
                style="fill:inherit;"
              >
                <g
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="inherit">
                    <path
                      d="M86,8.13074c-19.95469,0 -39.90938,7.59114 -55.09375,22.77551c-30.36875,30.36875 -30.36875,79.81875 0,110.1875c15.18437,15.18437 35.07188,22.84375 55.09375,22.84375c20.02188,0 39.90937,-7.65938 55.09375,-22.84375c30.36875,-30.36875 30.36875,-79.81875 0,-110.1875c-15.18438,-15.18437 -35.13906,-22.77551 -55.09375,-22.77551zM86,16.125c17.87188,0 35.7448,6.85208 49.45105,20.42395c27.27812,27.27812 27.27812,71.62187 0,98.76563c-27.27812,27.27812 -71.62187,27.27812 -98.76562,0c-27.27812,-27.14375 -27.28022,-71.4875 -0.13647,-98.76563c13.70625,-13.57187 31.57917,-20.42395 49.45105,-20.42395zM61.8125,81.96875c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h51.0625c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125z"
                    ></path>
                  </g>
                </g>
              </svg>
            </button>
          </span> 
        
          <span :class="`grid c_${component.subcomponents.quantity_input.id}__input c_${component.subcomponents.quantity_input.id}__input_${theme_id ?? ''}`">
            <div :class="`c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
              <input
                type="number"
                v-model.number="cross_sale_product.quantity"
                :class="`grid c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__input c_${component.subcomponents.quantity_input.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
              />
            </div>
          </span>
        
          <span :class="`grid c_${component.subcomponents.quantity_input.id}__increase_button c_${component.subcomponents.quantity_input.id}__increase_button_${theme_id ?? ''} c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container c_${component.subcomponents.quantity_input.subcomponents.button.id}__outer_container_${theme_id ?? ''}`">

            <button 
            :class="`c_${component.subcomponents.quantity_input.subcomponents.button.id}__button c_${component.subcomponents.quantity_input.subcomponents.button.id}__button_${theme_id ?? ''}`"
            @click="increaseQuantity">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 172 172"
                style="fill:inherit;"
              >
                <g
                  fill-rule="nonzero"
                  stroke="none"
                  stroke-width="1"
                  stroke-linecap="butt"
                  stroke-linejoin="miter"
                  stroke-miterlimit="10"
                  stroke-dasharray=""
                  stroke-dashoffset="0"
                  font-family="none"
                  font-weight="none"
                  font-size="none"
                  text-anchor="none"
                  style="mix-blend-mode: normal"
                >
                  <path d="M0,172v-172h172v172z" fill="none"></path>
                  <g fill="inherit">
                    <path
                      d="M86,8.13074c-19.95469,0 -39.90938,7.59114 -55.09375,22.77551c-30.36875,30.36875 -30.36875,79.81875 0,110.1875c15.18437,15.18437 35.20625,22.84375 55.09375,22.84375c19.8875,0 39.90937,-7.65938 55.09375,-22.84375c30.36875,-30.36875 30.36875,-79.81875 0,-110.1875c-15.18438,-15.18437 -35.13906,-22.77551 -55.09375,-22.77551zM86,16.125c17.87188,0 35.7448,6.85208 49.45105,20.42395c27.14375,27.27812 27.14375,71.62397 0,98.9021c-27.27812,27.27812 -71.62187,27.27812 -98.76562,0c-27.27812,-27.27812 -27.28022,-71.62397 -0.13647,-98.9021c13.70625,-13.57187 31.57917,-20.42395 49.45105,-20.42395zM86,56.4375c-2.28437,0 -4.03125,1.74687 -4.03125,4.03125v21.5h-21.5c-2.28438,0 -4.03125,1.74688 -4.03125,4.03125c0,2.28437 1.74687,4.03125 4.03125,4.03125h21.5v21.5c0,2.28437 1.74688,4.03125 4.03125,4.03125c2.28437,0 4.03125,-1.74688 4.03125,-4.03125v-21.5h21.5c2.28437,0 4.03125,-1.74688 4.03125,-4.03125c0,-2.28437 -1.74688,-4.03125 -4.03125,-4.03125h-21.5v-21.5c0,-2.28438 -1.74688,-4.03125 -4.03125,-4.03125z"
                    ></path>
                  </g>
                </g>
              </svg>
            </button>
          </span>
        </div>
      </div>

      <!-- Sku select -->

      <div v-if="cross_sale_product.skus && cross_sale_product.skus.length > 1"
      :class="`grid c_${component.id}__sku_select c_${component.id}__sku_select_${theme_id ?? ''}`">
        <div :class="`grid c_${component.subcomponents.form_input.id}__outer_container c_${component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
          <select
          :class="`c_${component.subcomponents.form_input.id}__input c_${component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
            v-model.number="cross_sale_product.selected_sku_id"
            @input="(val) => cross_sale_product.selected = val ? true : cross_sale_product.selected"
          >
            <option
              :value="item.id"
              v-for="item in cross_sale_product.skus"
              :key="item.id"
            >
              {{ item.display_name }}
            </option>
          </select>
        </div>
        
      </div>

      <!-- Customer input -->

      <div v-if="cross_sale_product.product.requires_customer_input" :class="`grid containable c_${component.id}__input c_${component.id}__input_${theme_id ?? ''}`">
          <div :class="`grid c_${component.subcomponents.form_input.id}__outer_container c_${component.subcomponents.form_input.id}__outer_container_${theme_id ?? ''}`">
            <label :for="`customer_content${cross_sale_product.id}`" :class="`grid c_${component.subcomponents.form_input.id}__label c_${component.subcomponents.form_input.id}__label_${theme_id ?? ''}`"
          >{{  cross_sale_product.product.customer_input_label }}<sup class="text-red-600">*</sup></label
        >
            <input
            :id="`customer_content${cross_sale_product.id}`"
            ref="customer_content"  
            type="text"
            @input="(val) => cross_sale_product.selected = val ? true : cross_sale_product.selected"
            v-model="cross_sale_product.customer_content"
            :class="`grid c_${component.subcomponents.form_input.id}__input c_${component.subcomponents.form_input.id}__input_${theme_id ?? ''}`"
          />
          <span
          :class="`grid c_${component.subcomponents.form_input.id}__error c_${component.subcomponents.form_input.id}__error_${theme_id ?? ''}`"
            role="alert"
            v-if="errors[`cross_sale_products${cross_sale_product.id}`]"
          >
            {{ errors[`cross_sale_products${cross_sale_product.id}`] }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  props: {
    cross_sale_product: Object,
    errors: Object,
    component: Object,
    theme_id: Number,
  },
  computed: {
    showCrossSaleProduct() {
      return this.cross_sale_product?.set || this.cross_sale_product?.skus?.length
        ? true
        : false
    },
    selected_sku() {
      return this.cross_sale_product.skus?.find(
        (sku) => sku.id === this.cross_sale_product.selected_sku_id
      );
    },
    price() {
      return this.special ? this.special_price : this.regularPrice;
    },
    regularPrice() {
      return this.useProductPrice
        ? this.cross_sale_product.product.price
        : this.selected_sku?.price;
    },
    useProductPrice() {
      return this.cross_sale_product.set;
    },
    special() {
      return this.useProductPrice
        ? this.productSpecial
        : this.selectedSkuSpecial;
    },
    productSpecial() {
      return this.cross_sale_product.product.current_specials &&
        this.cross_sale_product.product.current_specials.length
        ? this.cross_sale_product.product.current_specials[0]
        : null;
    },
    selectedSkuSpecial() {
      return this.selected_sku?.current_specials &&
        this.selected_sku?.current_specials.length
        ? this.selected_sku.current_specials[0]
        : null;
    },
    special_price() {
      return this.special?.pivot?.special_price ?? null;
    },
  },
  watch: {
    selected_sku(sku) {
      this.setPrice();
    },
  },
  methods: {
    formatPrice(price) {
      return (price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setPrice() {
      this.cross_sale_product.price = this.price;
      this.cross_sale_product.regular_price = this.regularPrice;
      this.cross_sale_product.special_price = this.special_price;
    },
    decreaseQuantity() {
      this.cross_sale_product.quantity = this.cross_sale_product.quantity === 1 ? 1 : (this.cross_sale_product.quantity -= 1);
    },
    increaseQuantity() {
      this.cross_sale_product.quantity++;
      this.cross_sale_product.selected = true
    },
  },
  mounted() {
    this.setPrice();
  },
};
</script>